<style lang="less" scoped>
@import '../../global.less';
.bind-mobile {
  min-height: 100vh;
  .header-layer {
    height: 44px;
  }
  .logo {
    font-size: 135px;
    text-align: center;
    .title {
      height: 75px;
      background: rgba(255, 252, 248, 1);
      margin-bottom: 50px;
      .main {
        font-size: 17px;
        font-weight: 400;
        color: rgba(25, 26, 27, 1);
        line-height: 23px;
        text-align: center;
        margin-bottom: 5px;
        img {
          width: 25px;
          height: 25px;
          position: relative;
          top: 6px;
        }
      }
      .desc {
        height: 23px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(121, 125, 130, 1);
        line-height: 23px;
        text-align: center;
      }
    }
  }
  .agreement {
    margin: 30px 0;
    position: absolute;
    width: 100%;
    text-align: center;
    .agreement-text {
      display: inline;
      font-size: 11px;
      color: rgb(121, 125, 130);
      .agreement-link {
        color: rgb(25, 26, 27);
      }
    }
  }
  .bind-form {
    width: 100%;
    .form-group {
      line-height: 55px;
      margin: 0 25px;
      position: relative;

      &::after {
        .bottomLine();
      }
      .errorTip {
        color: rgb(192, 49, 49);
      }
    }
    input::-webkit-input-placeholder {
      color: #bdc0c5;
    }
    input::-moz-placeholder {
      color: #bdc0c5;
    }
    input:-moz-placeholder {
      color: #bdc0c5;
    }
    input:-ms-input-placeholder {
      color: #bdc0c5;
    }
    .input-control {
      border: none;
      width: 100%;
      height: 55px;
      font-size: 15px;
      outline: none;
    }
    .submit {
      line-height: 45px;
      font-size: 16px;
      margin: 0 25px;
      border-radius: 3px;
      text-align: center;
      background-color: rgb(236, 236, 236);
      height: 44px;
      color: rgba(225, 225, 225, 0.3);
      border: none;
    }
    .canSubmit {
      color: rgb(225, 225, 225, 0.3);
    }
    .bind-btn {
      margin-top: 35px;
      background-color: rgb(192, 49, 49);
    }
    .sm-text-left {
      margin-top: 18px;
      margin-left: 25px;
      float: left;
      color: rgb(121, 125, 130);
      font-size: 13px;
    }
    .sm-text-right {
      margin-top: 18px;
      margin-right: 25px;
      float: right;
      color: rgb(121, 125, 130);
      font-size: 13px;
    }
    .getSmsCode {
      font-size: 13px;
      position: absolute;
      top: 25px;
      right: 0;
    }

    .eye {
      font-size: 13px;
      position: absolute;
      top: 8px;
      right: 0;
      display: inline-block;
    }
    .successIcon {
      font-size: 21px !important;
      position: absolute;
      top: 1px;
      left: 45px;
      display: inline-block;
      color: rgb(85, 175, 60);
      i {
        font-size: 21px;
      }
    }
    .imgCaptcha {
      position: absolute;
      top: 8px;
      right: 0;
      text-align: right;
      img {
        height: 26px;
      }
    }
    .ic-pic {
      height: 26px;
      position: absolute;
      right: 0;
      top: 13px;
    }
  }
}
</style>

<template>
  <div class="bind-mobile" ref="bindBody">
    <myHeader :showHome="false" :showBack="true">
      <div slot="title">手机号绑定</div>
    </myHeader>
    <div class="header-layer"></div>
    <div class="logo">
      <div class="title">
        <div class="main"><img src="../../image/red_tips.png" />请绑定手机号</div>
        <div class="desc">以保护您账户安全并为您提供更多服务</div>
      </div>
    </div>
    <div class="bind-form">
      <form>
        <div class="form-group">
          <input
            @keydown="cleanMobileSmsErr"
            id="bind-mobile"
            type="tel"
            maxlength="13"
            class="input-control"
            v-model="input.mobile"
            placeholder="请输入手机号"
          />
        </div>
        <div class="form-group" v-if="isShowSmsImgCaptcha">
          <input @keydown="cleanMobileSmsErr" class="input-control" v-model="input.imgCaptchaCode" placeholder="图形验证码" />
          <div class="successIcon" v-if="smsImgCaptchaStatus === 'checking'">
            <loading-vc size="17px"></loading-vc>
          </div>
          <div v-else-if="smsImgCaptchaStatus === 'ok'">
            <icon-vc class="successIcon" name="icon-dingdan-yiquxiao"></icon-vc>
          </div>
          <img :src="imgCaptchaAddress" alt class="ic-pic" @click="getImgCaptchaCode" />
          <div v-show="errorTip" class="errorTip">{{ errorTip }}</div>
        </div>

        <div class="form-group">
          <input
            @keydown="cleanMobileSmsErr"
            class="input-control"
            v-model="input.smsCode"
            placeholder="请输入验证码"
            @focus="testFocus"
            @blur="testBlur"
            ref="smsRefs"
            maxlength="6"
          />
          <sms-code-vc
            class="getSmsCode"
            :times="60"
            :status="smsStatus"
            :pos="smsPos"
            :disable="isSmsDisable"
            :resetCountdown="resetCountdown"
            v-on:smsCodeClick="getSmsCaptchaCode"
          ></sms-code-vc>
        </div>
        <div class="form-group" v-if="isShowBindImgCaptcha">
          <input @keydown="cleanMobileSmsErr" class="input-control" v-model="input.imgCaptchaCode" placeholder="图形验证码" />
          <img :src="imgCaptchaAddress" alt class="ic-pic" @click="getImgCaptchaCode" />
          <div v-show="errorTip" class="errorTip">{{ errorTip }}</div>
        </div>
        <div :class="canSubmit ? 'submit bind-btn canSubmit ' : 'submit bind-btn'" @click="bindMobile">确定</div>
      </form>
    </div>
    <alert-vc :aVisible="alertContent" :aContent="alertContent" v-on:clickOk="alertClickOk"></alert-vc>
  </div>
</template>
<script>
import _ from 'underscore'
import op from 'object-path'
import myHeader from '@comp/header'
import imageCaptcha from '@comp/image_captcha'
import smsCodeVc from '@comp/sms_code'
import notLogged from '@comp/not_logged'
import iconVc from '@comp/icon'
import alertVc from '@comp/alert'
import loadingVc from '@comp/loading.vue'
import userService from '@svc/user'
import Service from '@svc/login'
import CONSTANT from '@con/login'
import account from '@lib/account'
import { MessageBox, Toast } from 'mint-ui'
import { MobileReg, jump, getLoginExtData } from '@util/function'
import setDocumentTitle from '@util/document-title'

const INVALID_MOBILE_TIP = '请输入11位正确的手机号码'
const EMPTY_MOBILE_TIP = '请输入手机号'
const SMS_IMG_STATUS_IS_NONE = 'none'
const IMG_CAPTCHA_TYPE_IS_SMS = 'sms'
const IMG_CAPTCHA_TYPE_IS_BIND = 'bind'

const view = {
  data() {
    return {
      redirectUri: '',
      extra: getLoginExtData(),
      isShowSmsImgCaptcha: false,
      isShowBindImgCaptcha: false,
      smsCode: '',
      newPwd: '',
      smsImgCaptchaStatus: SMS_IMG_STATUS_IS_NONE,
      smsStatus: 1,
      isSmsDisable: true,
      isPswVisible: true,
      resetCountdown: false,
      imgCaptchaCode: '',
      imgCaptchaLength: -1,
      imgCaptchaAddress: '',
      imgCaptchaKey: '',
      alertContent: '',
      errorTip: '',
      input: {
        password: '',
        smsCode: '',
        mobile: '',
        imgCaptchaKey: '',
        imgCaptchaCode: '',
      },
      logo: {
        'font-size': '25.9px',
        display: 'inline-block',
        width: '53px',
        'line-height': '53px',
      },
      smsPos: {
        position: 'absolute',
        right: 0,
        top: '14px',
      },
    }
  },
  computed: {
    canSubmit: function () {
      const mobile = this.input.mobile.replace(/\s/g, '')
      return (
        (mobile + '').length === 11 &&
        (this.input.smsCode + '').length !== 0 &&
        (this.isShowSmsImgCaptcha ? (this.input.imgCaptchaCode + '').length !== 0 && this.smsImgCaptchaStatus === 'ok' : true)
      )
    },
  },
  watch: {
    'input.imgCaptchaCode': function (v) {
      if (v.length > 0 && v.length === this.imgCaptchaLength) {
        this.checkImgValidation()
      }
    },
    'input.mobile': function (v) {
      const mobile = v.replace(/\s/g, '')
      if (mobile.length === 11) {
        return (this.isSmsDisable = false)
      }
      this.resetCountdown = +new Date()
      this.isSmsDisable = true
    },
  },
  components: {
    'image-captcha': imageCaptcha,
    'sms-code-vc': smsCodeVc,
    'not-logged': notLogged,
    'icon-vc': iconVc,
    'alert-vc': alertVc,
    'loading-vc': loadingVc,
    myHeader,
  },
  methods: {
    cleanErr(type) {
      this[type] = ''
      this.errorTip = ''
    },
    cleanError(type) {
      this.cleanErr(type)
    },
    cleanMobileSmsErr: function () {
      this.errorTip = ''
      const mobile = this.input.mobile.replace(/\s/g, '')
      this.input.mobile = this.formatNumber(mobile)
    },
    formatNumber(str) {
      const string = str
      const len = string.length || 0
      if (len <= 3) {
        return string
      } else if (len > 3 && len <= 7) {
        return string.substr(0, 3) + ' ' + string.substr(3, 4)
      } else if (len > 7 && len <= 11) {
        return string.substr(0, 3) + ' ' + string.substr(3, 4) + ' ' + string.substr(7, 4)
      } else {
        return string
      }
    },
    bindMobile: function () {
      const self = this

      document.body.scrollTop = document.documentElement.scrollTop = 0
      document.body.scrollIntoView()

      if (!this.input.mobile) {
        return this.showToast('请输入手机号')
      }

      if (!this.input.smsCode) {
        return this.showToast('请输入验证码')
      }

      if (!this.canSubmit) {
        return
      }

      const mobile = this.input.mobile.replace(/\s/g, '')
      Service.thirdBindPhone({
        loginToken: this.$route.query.loginToken,
        mobile: String(mobile),
        smsCode: self.input.smsCode,
        imgKey: self.imgCaptchaKey,
        imgCode: self.input.imgCaptchaCode,
      })
        .then((data) => {
          // 联名登录
          this.saveAndJump(data)
        })
        .catch((err) => {
          console.error(err)
          if (err.status == 6006 || err.status == 6007) {
            self.showImgCaptcha(IMG_CAPTCHA_TYPE_IS_BIND)
            self.errorTip = err.msg
            return
          }
          if (err.status == 70005) {
            MessageBox.alert(err.msg).then((action) => {
              this.$router.go(-1)
            })
            return
          }
          self.errorTip = ''
          self.alertContent = err.msg
        })
    },
    saveAndJump(res) {
      // 保存登录信息，跳转首页
      account.setLoginSuccessData(res)
      this.redirectUri = decodeURIComponent(op(this.$route).get('query.cb') || '') || this.getRedirectUri(res.mallInfo.mallCode)
      jump({ url: this.redirectUri })
    },
    getRedirectUri(code) {
      return process.env.VUE_APP_KAOP_MALL_HOST + '/ka/' + code
    },
    showToast(msg) {
      Toast({
        message: msg,
        position: 'bottom',
        duration: 3000,
      })
    },
    checkImgValidation: _.debounce(function () {
      const autoCheck = true
      if (this.isSmsDisable) {
        return
      }
      this.smsImgCaptchaStatus = 'checking'
      this.getSmsCaptchaCode(autoCheck).then(
        () => {
          this.smsImgCaptchaStatus = 'ok'
        },
        (e) => {
          this.smsImgCaptchaStatus = SMS_IMG_STATUS_IS_NONE
        },
      )
    }, 500),
    alertClickOk: function () {
      this.alertContent = ''
    },
    getImgCaptchaCode: function (type) {
      //获取验证码图片
      const self = this
      self.imgCaptchaType = type
      userService
        .getImgCaptcha()
        .then((data) => {
          self.imgCaptchaAddress = data.imgUrl
          self.imgCaptchaKey = data.imgKey
          self.imgCaptchaLength = data.length
        })
        .catch((e) => {
          this.errorTip = e.msg
        })
    },
    isInvalidMobile: function (m) {
      m = m.replace(/\s/g, '')
      return m == '' ? EMPTY_MOBILE_TIP : MobileReg.test(m) ? '' : INVALID_MOBILE_TIP
    },
    showImgCaptcha(type) {
      if (type === IMG_CAPTCHA_TYPE_IS_BIND) {
        this.isShowBindImgCaptcha = true
      } else if (type === IMG_CAPTCHA_TYPE_IS_SMS) {
        this.isShowSmsImgCaptcha = true
      }
      return this.getImgCaptchaCode(type)
    },
    getSmsCaptchaCode: function (autoCheck) {
      const self = this
      const invalidMsg = this.isInvalidMobile(this.input.mobile)
      if (invalidMsg) {
        return (this.alertContent = invalidMsg)
      }
      const mobile = this.input.mobile.replace(/\s/g, '')
      return Service.smsSend({
        type: `${CONSTANT.GET_MSG_TYPE_LOGIN}`,
        mobile: String(mobile),
        imgKey: self.imgCaptchaKey,
        imgCode: self.input.imgCaptchaCode,
      })
        .then(() => {
          self.errorTip = ''
          return
        })
        .catch((err) => {
          if (err.status === 6007 || err.status === 6006) {
            self.showImgCaptcha(IMG_CAPTCHA_TYPE_IS_SMS)
            self.errorTip = err.msg
            self.smsStatus = 2
            if (autoCheck) {
              throw err
            }
            return
          }
          self.errorTip = ''
          self.alertContent = err.msg
          if (autoCheck) {
            throw err
          }
        })
    },
    testFocus(e) {
      console.log('focus---', e)
    },
    testBlur(e) {
      console.log('blur---', e)
      document.body.scrollTop = document.documentElement.scrollTop = 0
      this.$refs.bindBody.scrollTop = 0
      this.$refs.bindBody.scrollIntoView()
    },
  },
  mounted() {
    setDocumentTitle('手机号绑定')
  },
}
export default view
</script>
